import { render, staticRenderFns } from "./notes-view-section.html?vue&type=template&id=31931149&scoped=true&"
import script from "./notes-view-section.js?vue&type=script&lang=js&"
export * from "./notes-view-section.js?vue&type=script&lang=js&"
import style0 from "./notes-view-section.scss?vue&type=style&index=0&id=31931149&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31931149",
  null
  
)

export default component.exports